module.exports = __webpack_public_path__ + "static/media/25488210_1703512739723910_3491237446747863956_o.20ae34ee.jpg";